module.exports = __webpack_public_path__ + "img/delivery-date.ac43c543.svg";